import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

let componentDirs = [
	[ require.context('optinmonster-js-library/src/vue/campaigns/components', true, /\.vue$/) ],
	[ require.context('optinmonster-js-library/src/vue/campaigns/components/svg', true, /\.vue$/), 'svg' ],
	[ require.context('optinmonster-js-library/src/vue/components', true, /\.vue$/) ],
	[ require.context('@/components/svg', true, /\.vue$/), 'svg' ],
	[ require.context('@/components', true, /\.vue$/) ],
	[ require.context('@/about/components', true, /\.vue$/), 'about' ],
	[ require.context('@/dashboard/components', true, /\.vue$/), 'dashboard' ],
	[ require.context('@/notifications/components', true, /\.vue$/), 'notifications' ],
	[ require.context('@/monsterleads/components', true, /\.vue$/), 'monsterleads' ],
	[ require.context('@/templates/components', true, /\.vue$/), 'templates' ],
	[ require.context('@/campaigns/components', true, /\.vue$/), 'campaigns' ],
	[ require.context('@/wizard/components', true, /\.vue$/), 'wizard' ],
	[ require.context('@/settings/components', true, /\.vue$/), 'settings' ],
	[ require.context('@/university/components', true, /\.vue$/), 'university' ],
	[ require.context('@/personalization/components', true, /\.vue$/), 'personalization' ],
]

componentDirs.forEach(([ requireComponent, prefix ]) => {
	requireComponent.keys().forEach(fileName => {
		const componentConfig = requireComponent(fileName)

		let componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
		if (prefix) {
			componentName = prefix + '/' + componentName
		}
		componentName = upperFirst(camelCase(componentName))

		Vue.component(componentName, componentConfig.default || componentConfig)
	})
})
